<template>
  <div class="wrap-nav">
    <Nav />

    <div class="wrap-content">
      <template v-for="(menu, index) in menuAwards">
        <component :key="index" v-if="menu.isActive" :is="menu.componentName" />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'

const Nav = () => import('./Parts/Nav')
const Rules = () => import('./Rules/Main')
const Judges = () => import('./Judges/Main')
const Categories = () => import('./Categories/Main')

export default {
  components: {
    Nav,
    Rules,
    Judges,
    Categories
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      navAwards: state => state.nav.navAwards
    }),

    menuAwards () {
      return this.navAwards
        .map(menu => {
          const mConfig = this.configMap.get(menu.tabName)

          if (mConfig) {
            menu.isDisplay = mConfig.isDisplay
            menu.isActive = mConfig.isActive
            menu.title = mConfig.name ? mConfig.name : menu.title
            menu.dec = mConfig.des ? mConfig.des : menu.dec

            if (menu.tabName === 'judges') {
              const yConfig = this.configMap.get('yearConfig')
              menu.dec = yConfig ? yConfig.name : 2023
            }
          }

          return menu
        })
        .filter(menu => menu.isDisplay)
    }
  },

  created () {
    this.$store.dispatch('awards/getRules')
    this.$store.dispatch('awards/getJudgeCate')
    this.$store.dispatch('awards/getJudgeList', 1)
    this.$store.dispatch('awards/getCateList')
    this.$store.dispatch('awards/getLinks')
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
</style>
